import * as Sentry from '@sentry/react'
import { LayoutContext } from './components'
import { AppRoutes } from './AppRoutes.tsx'
import { AppErrorFallback } from './components/AppErrorFallback'
import 'react-phone-number-input/style.css'
import '@mantine/notifications/styles.css'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/charts/styles.css'
import './index.css'
import { Loading } from '@medplum/react'
import { Suspense } from 'react'

function App() {
  return (
    <LayoutContext>
      <Sentry.ErrorBoundary
        fallback={({ resetError, error }) => (
          <AppErrorFallback error={error} onReset={resetError} />
        )}
      >
        <Suspense fallback={<Loading />}>
          <AppRoutes />
        </Suspense>
      </Sentry.ErrorBoundary>
    </LayoutContext>
  )
}

export default App
